/**
 * Sanitize a user-submitted URL before use as an `href`. Allows http(s),
 * mailto, tel, and tg schemes; blocks javascript:/data:/vbscript:/file:.
 * Bare strings ("github.com/foo") get prefixed with `https://`. Returns
 * null when the input is unsafe or unrenderable as a link.
 */
export function safeUrl(raw: string | null | undefined): string | null {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (!s) return null;
  const allowedScheme = /^(https?|mailto|tel|tg):/i;
  const blockedScheme = /^\s*(javascript|data|vbscript|file):/i;
  if (blockedScheme.test(s)) return null;
  if (allowedScheme.test(s)) return s;
  if (s.startsWith("@")) return null; // Telegram-style handle, render as text
  if (/[\s<>"'`]/.test(s)) return null;
  return `https://${s}`;
}
